export enum eTypeAsnSource {
  'Manual' = 1,
  'API' = 2
}
